export default __webpack_public_path__ + "static/media/008.657cf6f3.png";